// extracted by mini-css-extract-plugin
export default {"text":"ZdrLm","link":"b4NHY","link-arrow":"nsI5K"};